interface EmailProps {
  user: string;
  message: string;
  de: string;
  para: string;
  assunto: string;
  horario: string;
}

interface SentEmailsProps {
  email: EmailProps;
}

export const SentEmails = ({ email }: SentEmailsProps) => {
  return (
    <div className="my-2 rounded border border-primary p-2">
      <div className="my-1 flex items-center justify-between px-1 text-sm">
        <div>
          <p>
            De: <strong className="font-medium">{email.de}</strong>
          </p>
          <p>
            Para: <strong className="font-medium">{email.para}</strong>
          </p>
          <p>
            Assunto: <strong className="font-medium">{email.assunto}</strong>
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-400">{email.horario}</p>
        </div>
      </div>

      <div className="block max-w-5xl rounded-lg border border-gray-200 bg-gray-100 px-4 py-2 shadow-sm">
        <p className="text-sm">{email.message}</p>
      </div>
    </div>
  );
};
